/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { Prompt, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { AppContext } from "components/AppContext";
import Loading from "shared/Loading";
import {
  Alert,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalFooter
} from "reactstrap";
import moment from "moment";
import _ from "underscore";
import Block from "./Block";
import DagsDropdown from "./DagsDropdown";
import Datasets from "./Datasets";
import Filters from "./Filters";
import Fields from "./Fields";
import Schedule from "./Schedule";
import SaveButtons from "./SaveButtons";
import IncrementalData from "./IncrementalData";
import { defaultTimezone, extractModel } from "./utils";

const ExtractBuilder = () => {
  // configs
  const { StoreAPIDefaults, config, signOut } = useContext(AppContext);

  const baseURL = config.configApiBaseUrl;
  const { extractId, dagId } = useParams();
  const history = useHistory();

  // all data for UI
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [report, setReport] = useState(null);
  const [dagsList, setDagsList] = useState(null);
  const [datasetsList, setDatasetsList] = useState(null);
  const [datasetsRelationships, setDatasetsRelationships] = useState(null);
  const [datasetsFieldsList, setDatasetsFieldsList] = useState(null);
  const [incrementalDataShow, setIncrementalDataShow] = useState(false);

  // used for validation and if changes occurred
  const [nameOnLoad, setNameOnLoad] = useState();
  const [filtersOnLoad, setFiltersOnLoad] = useState();
  const [fieldsOnLoad, setFieldsOnLoad] = useState();
  const [scheduleOnLoad, setScheduleOnLoad] = useState();
  const [incrementalsOnLoad, setIncrementalsOnLoad] = useState([""]);
  const [invalidName, setInvalidName] = useState(false);

  // selected data to compose extract
  const [dag, setDag] = useState("");
  const [datasets, setDatasets] = useState([]);
  const [filters, setFilters] = useState([]);
  const [fields, setFields] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [schedule, setSchedule] = useState("");
  const [timezone, setTimezone] = useState(defaultTimezone);
  const [expiration, setExpiration] = useState("");
  const [incrementalDatasets, setIncrementalDatasets] = useState([""]);

  const [extract, setExtract] = useState(extractModel);
  const [save, setSave] = useState(false);
  const [saveOpen, setSaveOpen] = useState(false);
  const [saveRunOpen, setSaveRunOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [run, setRun] = useState(false);
  const [asNew, setAsNew] = useState();
  const [leaveAlert, setLeaveAlert] = useState(false);

  const selectedAccountDetails = JSON.parse(
    localStorage.getItem("accountDeatils")
  );
  const { id: accountId, name: accountName } = selectedAccountDetails;

  const toggleSave = () => setSaveOpen(!saveOpen);
  const toggleSaveRun = () => setSaveRunOpen(!saveRunOpen);
  const toggleModal = (runReport, asNewReport) => {
    setModal(!modal);
    setRun(runReport);
    setAsNew(asNewReport);
  };

  const getDags = () => {
    setLoading("Getting Data Access Groups");
    const url = `${baseURL}/accounts/${accountId}/dags`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
        }
      })
      .then(response => {
        setDagsList(response.data.data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        if (err?.response?.status === 401) {
          signOut();
        } else {
          history.push({
            pathname: "/app/errordisplay",
            state: {
              error: err
            }
          });
        }

        setLoading(false);
        setError(err.response.statusText);
      });
  };

  const getDatasets = () => {
    setLoading("Getting Dataset Options");
    const url = `${baseURL}/accounts/${accountId}/dags/${dag}/datasets`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
        }
      })
      .then(response => {
        setDatasetsList(response.data.data);
        // setLoading(false);
      })
      .catch(err => {
        console.log(err);
        history.push({
          pathname: "/app/errordisplay",
          state: {
            error: err
          }
        });
        setLoading(false);
        setError(err.response.statusText);
      });
  };

  const getFields = () => {
    setLoading("Getting Dataset Field Options");
    const newDatasetsFields = [];
    const newDatasetsRelationships = {};
    let count = 0;

    datasetsList.forEach(dataset => {
      const url = `${baseURL}/accounts/${accountId}/dags/${dag}/datasets/${dataset.id}?properties=1`;
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
          }
        })
        .then(response => {
          const ds = response.data.data[0];
          newDatasetsRelationships[ds.id] = [ds.id];

          Object.entries(ds.properties).forEach(([field_id, field]) => {
            if (field.display === "true") {
              const obj = field;
              obj.id = field_id;
              obj.dataset = ds.id;
              newDatasetsFields.push(obj);
            }
          });

          Object.entries(ds.relationships).forEach(([field_id]) => {
            newDatasetsRelationships[ds.id].push(field_id);
          });

          count += 1;
          if (count === datasetsList.length) {
            setDatasetsRelationships(newDatasetsRelationships);
            setDatasetsFieldsList(newDatasetsFields);
            setLoading(false);
          }
        })
        .catch(err => {
          history.push({
            pathname: "/app/errordisplay",
            state: {
              error: err
            }
          });
          setError(err.response.statusText);
        });
    });
  };

  const getReport = (dagId, extractId) => {
    const url = `${baseURL}/accounts/${accountId}/dags/${dagId}/reports/${extractId}?epoch=${Date.now()}`;
    
    setLoading("Getting Extract");

    if (dagId && extractId) {
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
          }
        })
        .then(
          response => {
            setReport(response.data.data[0]);
            setNameOnLoad(response.data.data[0].reporttitle);
            setLoading(false);
            setLeaveAlert(false);
          },
          error => {
            history.push({
              pathname: "/app/errordisplay",
              state: {
                error: error
              }
            });
            setError("Sorry, we couldn't load that extract.");
            setLoading(false);
            return Promise.reject(error);
          }
        );
    } else {
      setError("Sorry, that is not a valid extract id.");
      setLoading(false);
    }
  };

  const saveReport = (runReport, asNewReport) => {
    const method = report && report.reportid && !asNewReport ? "put" : "post";
    const url =
      report && report.reportid && !asNewReport
        ? `${baseURL}/accounts/${accountId}/dags/${dag}/reports/${report.reportid}`
        : `${baseURL}/accounts/${accountId}/dags/${dag}/reports`;

    const data = {
      reporttitle: extract.name,
      reportdescription: extract.description,
      reporttimezone: extract.timezone || defaultTimezone,
      reportproperties: [],
      reportschedule: extract.schedule || null,
      reportissaveandrun: runReport,
      rawdata: btoa(JSON.stringify(extract))
    };

    let newVersion = {
      // version: 2,
      reporttitle: extract.name,
      reportdescription: extract.description,
      reporttimezone: extract.timezone || defaultTimezone,
      reportschedule: extract.schedule || null,
      reportissaveandrun: runReport,
      reportproperties: [
        {
          version: 2,
          schemas: [],
          columns: [],
          incremental: [],
          filters: []
        }
      ],
      rawdata: null
    };

    if (extract.expiration) {
      data.reportexpireon = String(extract.expiration);
      newVersion.reportexpireon = String(extract.expiration);
    }

    let primary = true;
    extract.datasets.forEach(dataset => {
      const obj = {
        id: dataset,
        incremental: incrementalDataShow
          ? incrementalDatasets.includes(dataset)
          : false,
        columns: [],
        filters: {}
      };

      if (primary) {
        obj.isprimary = true;
        primary = false;
        newVersion.reportproperties[0].isprimary = dataset;
      }

      newVersion.reportproperties[0].schemas.push(dataset);

      if (incrementalDataShow && incrementalDatasets.includes(dataset)) {
        newVersion.reportproperties[0].incremental.push(dataset);
      }

      extract.fields
        .filter(e => e.dataset_id === dataset)
        .forEach(field => {
          obj.columns.push(field.field_id);
          newVersion.reportproperties[0].columns.push(
            `${dataset}.${field.field_id}`
          );
        });
    });

    if (extract.filters.length > 0 && extract.filters[0].or.length > 0) {
      newVersion.reportproperties[0].filters.push({ or: [] });
      extract.filters[0].or.forEach((group, index) => {
        newVersion.reportproperties[0].filters[0].or[index] = { and: [] };
        group.and.forEach(filter => {
          const { dataset, field, operator, value } = filter;
          newVersion.reportproperties[0].filters[0].or[index].and.push({
            [`${dataset}.${field}`]: {
              [operator]:
                operator === "ilk" || operator === "inlk"
                  ? `%${value.toLowerCase()}%`
                  : value
            }
          });
        });
      });
    }

    setLoading("Saving Extract");

    axios({
      method,
      headers: {
        Authorization: `Bearer ${StoreAPIDefaults.accessToken}`,
        "Content-Type": "application/json"
      },
      url,
      data: newVersion
    })
      .then(response => {
        const { accountid, dagid, reportid } = response.data.data[0];

        setSuccess("Your extract is saved");
        const reports_url = `/app/account/${accountid}`;
        const report_url = `/app/account/${accountid}/dags/${dagid}/reports/${reportid}?epoch=${Date.now()}`;
        history.push(runReport ? reports_url : report_url);
      })
      .catch(err => {
        history.push({
          pathname: "/app/errordisplay",
          state: {
            error: err
          }
        });
        setError(err.response.statusText);
      })
      .finally(() => {
        setLoading("");
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
  };

  const validateReport = (runReport, asNewReport) => {
    // clear errors
    setError("");
    setInvalidName(false);

    // count errors
    let errors = 0;
    if (extract.filters.length > 0 && extract.filters[0].or.length > 0) {
      extract.filters[0].or.forEach(group => {
        group.and.forEach(filter => {
          _.mapObject(filter, filterSet => {
            if (filterSet === "" || filterSet === null) {
              errors += 1;
            }
          });
        });
      });
    }

    // show errors or continue
    if (errors > 0) {
      setError("The extract cannot be saved with incomplete filters");
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      return false;
    }

    // force name change if same
    if (asNewReport && nameOnLoad === name) {
      toggleModal(runReport, asNewReport);
      setName(`${name}--copy`);
      return false;
    }

    const allowedCharacters = /([^a-zA-Z0-9\-_ ]+)/gi;
    const testName = name.trim().replaceAll(allowedCharacters, "");
    if (name.length !== testName.length) {
      setError("Report names can only include a-Z 0-9 - _ and spaces");
      setInvalidName(true);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      return false;
    }

    setRun(runReport);
    setAsNew(asNewReport);
    setLeaveAlert(false);
    saveReport(runReport, asNewReport);

    return true;
  };

  useEffect(() => {
    if (accountId) {
      setDagsList(null);
      setDatasetsList(null);
      setDatasetsFieldsList(null);
      setDatasets([]);
      setFilters([]);
      setFields([]);
      setExtract(e => ({
        ...e,
        account_id: accountId
      }));
      getDags();
    }
  }, [accountId]);

  useEffect(() => {
    if (dagsList && dagsList.length > 0) {
      setDag(dagsList[0].dagid);
    }
  }, [dagsList]);

  useEffect(() => {
    if (dag) {
      setExtract(e => ({
        ...e,
        dag_id: dag
      }));
      setDatasetsList(null);
      setDatasetsFieldsList(null);
      setDatasets([]);
      setFilters([]);
      setFields([]);
      getDatasets();
    }
  }, [dag]);

  useEffect(() => {
    if (datasetsList) {
      setDatasetsFieldsList(null);
      getFields();
    }
  }, [datasetsList]);

  useEffect(() => {
    let newFilters = [...filters];
    if (newFilters.length > 0 && newFilters[0].or) {
      newFilters[0].or.forEach((group, index) => {
        newFilters[0].or[index].and = group.and.filter(item => {
          return datasets.includes(item.dataset);
        });
      });
      newFilters[0].or.forEach((group, index) => {
        if (newFilters[0].or[index].and.length < 1) {
          newFilters[0].or.splice(index, 1);
        }
        if (newFilters[0].or.length < 1) {
          newFilters = [];
        }
      });
    }
    setFilters(newFilters);
    const newFields = fields.filter(item => {
      return datasets.includes(item.dataset_id);
    });
    setFields(newFields);
    setExtract(e => ({
      ...e,
      datasets,
      fields: newFields,
      filters: newFilters
    }));
  }, [datasets]);

  useEffect(() => {
    setExtract(e => ({
      ...e,
      filters
    }));
  }, [filters]);

  useEffect(() => {
    setExtract(e => ({
      ...e,
      fields
    }));
    if (fields.length === 0) {
      setSchedule("");
    }
  }, [fields]);

  useEffect(() => {
    setExtract(e => ({
      ...e,
      schedule
    }));
    if (schedule === "" || schedule === "none") {
      setTimezone(defaultTimezone);
      setExpiration("");
      setIncrementalDatasets([""]);
      setIncrementalDataShow(false);
    }
  }, [schedule]);

  useEffect(() => {
    setExtract(e => ({
      ...e,
      timezone
    }));
  }, [timezone]);

  useEffect(() => {
    setExtract(e => ({
      ...e,
      expiration
    }));
  }, [expiration]);

  useEffect(() => {
    setExtract(e => ({
      ...e,
      name,
      description
    }));
  }, [name, description]);

  useEffect(() => {
    setTimeout(() => {
      setSuccess("");
    }, 3000);
  }, [success]);

  useEffect(() => {
    const scheduleComplete =
      extract.schedule !== ""
        ? (extract.schedule && extract.expiration) ||
          (!extract.schedule && !extract.expiration)
        : true;

    setSave(
      !!(
        extract.account_id &&
        extract.dag_id &&
        extract.name !== "" &&
        extract.fields.length > 0 &&
        scheduleComplete
      )
    );
  }, [extract]);

  useEffect(() => {
    if (datasetsFieldsList && dagId && extractId) {
      getReport(dagId, extractId);
    }
  }, [datasetsFieldsList, dagId, extractId]);

  useEffect(() => {
    if (report) {
      setDag(report.dagid);
      setDatasets(report.reportdatasets);
      setName(report.reporttitle);
      setDescription(report.reportdescription);
      setSchedule(report.reportschedule !== null ? report.reportschedule : "");
      setScheduleOnLoad(
        report.reportschedule !== null ? report.reportschedule : ""
      );
      setTimezone(report.reporttimezone);
      setExpiration(
        report.reportschedule && report.reportexpireon
          ? report.reportexpireon
          : ""
      );
      let tempIncrementals = [];

      report.reportproperties.forEach(property => {
        if (property.incremental) {
          tempIncrementals = [...property.incremental];
        }
      });
      setIncrementalDatasets(
        tempIncrementals.length === 0 ? [""] : tempIncrementals
      );
      setIncrementalDataShow(tempIncrementals.length !== 0);
      setIncrementalsOnLoad(
        tempIncrementals.length === 0 ? [""] : tempIncrementals
      );
      if (tempIncrementals.length > 0) setIncrementalDataShow(true);

      // VERSION 1 RAWDATA -> VERSION 2
      if (report.rawdata) {
        // parse the base64 encoded extract model
        let data = atob(report.rawdata);
        data = JSON.parse(data);

        // remove fields and filters using deprecated fields
        const temp_fields = [];
        const temp_filters = [];

        data.fields.forEach(field => {
          const { dataset_id, field_id } = field;
          const list = datasetsFieldsList.filter(e => e.dataset === dataset_id);
          const exists = list.filter(e => e.id === field_id).length > 0;
          if (exists) {
            temp_fields.push(field);
          }
        });

        if (data.filters.length > 0) {
          temp_filters.push({ or: [{ and: [] }] });
        }
        data.filters.forEach(filter => {
          const { dataset, field } = filter;
          const list = datasetsFieldsList.filter(e => e.dataset === dataset);
          const exists = list.filter(e => e.id === field).length > 0;
          if (exists) {
            temp_filters[0].or[0].and.push(filter);
          }
        });

        setFilters(temp_filters);
        setFiltersOnLoad(temp_filters);
        setFields(temp_fields);
        setFieldsOnLoad(temp_fields);
      } else {
        const temp_fields = [];
        const temp_filters = [];
        let tempds;

        const isVersion2 =
          report.reportproperties[0].version &&
          report.reportproperties[0].version === 2;

        if (isVersion2) {
          const data = report.reportproperties[0];
          data.columns.forEach(str => {
            const dataset_id = str.split(".")[0];
            const field_id = str.split(".")[1];
            if (datasetsList !== null && datasetsFieldsList !== null) {
              const temp_dataset = datasetsList.filter(
                e => e.id === dataset_id
              )[0];
              if (temp_dataset) {
                const temp_field = datasetsFieldsList.filter(
                  e => e.dataset === temp_dataset.id && e.id === field_id
                )[0];
                temp_fields.push({
                  dataset_id,
                  dataset_name: temp_dataset.title,
                  field_id,
                  field_name: temp_field.alias
                });
              }
            }
          });

          if (data.filters.length > 0) {
            temp_filters.push({ or: [] });
            data.filters[0].or.forEach((group, index) => {
              if (group.and.length > 0) {
                temp_filters[0].or[index] = { and: [] };
              }
              group.and.forEach(filter => {
                const dataset_field = Object.keys(filter)[0];
                const operator_value = filter[dataset_field];
                const operator = Object.keys(operator_value)[0];
                const value = operator_value[operator];
                temp_filters[0].or[index].and.push({
                  dataset: dataset_field.split(".")[0],
                  field: dataset_field.split(".")[1],
                  operator,
                  value
                });
              });
            });
          }
        } else {
          report.reportproperties.forEach(dataset => {
            if (datasetsList !== null) {
              // eslint-disable-next-line prefer-destructuring
              tempds = datasetsList.filter(e => e.id === dataset.id)[0];
            }

            // convert to field object {dataset_id:"",dataset_name="",field_id:"",field_name:""}
            if (
              dataset.columns &&
              dataset.columns.length > 0 &&
              datasetsFieldsList &&
              typeof tempds === "object" &&
              tempds !== null
            ) {
              dataset.columns.forEach(column => {
                const temp_field = datasetsFieldsList.filter(
                  e => e.dataset === tempds.id && e.id === column
                )[0];
                if (temp_field) {
                  temp_fields.push({
                    dataset_id: tempds.id,
                    dataset_name: tempds.title,
                    field_id: temp_field.id,
                    field_name: temp_field.alias
                  });
                }
              });
            }

            // convert to filter object {dataset:"",field:"",operator:"",value:""}
            if (dataset.filters && dataset.filters.length > 0 && tempds) {
              dataset.filters.forEach(filter => {
                const temp_filter = {
                  dataset: tempds.id,
                  field: "",
                  operator: "",
                  value: ""
                };
                Object.entries(filter).forEach(([field, group]) => {
                  temp_filter.field = field;
                  Object.entries(group).forEach(([operator, value]) => {
                    temp_filter.operator = operator;
                    temp_filter.value = value;
                  });
                });
                temp_filters.push(temp_filter);
              });
            }
          });
        }
        setFields(temp_fields);
        setFieldsOnLoad(temp_fields);
        setFilters(temp_filters);
        setFiltersOnLoad(temp_filters);
      }
    }
  }, [report, history]);

  useEffect(() => {
    const scheduleSame =
      (report && report.reportschedule === null && extract.schedule === "") ||
      (report && (schedule === scheduleOnLoad || schedule === "0 * * * *"));

    const incrementalSame =
      (report &&
        incrementalDatasets[0] === "" &&
        incrementalsOnLoad[0] === "" &&
        !incrementalDataShow) ||
      (report &&
        incrementalDatasets[0] !== "" &&
        JSON.stringify(incrementalDatasets) ===
          JSON.stringify(incrementalsOnLoad));

    const reportExpiration =
      report && moment.unix(report.reportexpireon).format();
    const reportExpirationString = moment(reportExpiration)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .format();
    const formattedExpiration =
      typeof expiration === "number" && moment.unix(expiration).format();
    const formattedExpirationString =
      formattedExpiration &&
      moment(formattedExpiration)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format();
    const expirationLocal = !formattedExpirationString
      ? expiration
      : formattedExpirationString;

    // if unsaved changes on new report, else if changes in established report, else leavealert is false
    if (
      report === null &&
      (extract.name !== "" ||
        extract.description !== "" ||
        extract.datasets.length !== 0 ||
        extract.filters.length !== 0 ||
        extract.fields.length !== 0 ||
        schedule !== "" ||
        incrementalDatasets[0] !== "")
    ) {
      setLeaveAlert(true);
    } else if (
      report &&
      (extract.name !== report.reporttitle ||
        extract.description !== report.reportdescription ||
        extract.datasets !== report.reportdatasets ||
        JSON.stringify(extract.filters) !== JSON.stringify(filtersOnLoad) ||
        JSON.stringify(extract.fields) !== JSON.stringify(fieldsOnLoad) ||
        !scheduleSame ||
        extract.timezone !== report.reporttimezone ||
        reportExpirationString !== expirationLocal ||
        !incrementalSame)
    ) {
      setLeaveAlert(true);
    } else {
      setLeaveAlert(false);
    }
  }, [
    report,
    extract,
    fieldsOnLoad,
    filtersOnLoad,
    schedule,
    incrementalDatasets,
    incrementalsOnLoad,
    incrementalDataShow,
    schedule
  ]);

  useEffect(() => {
    const alertUser = e => {
      if (leaveAlert) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    // here is where you would listen for page change or refresh
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  return (
    <div className="page builder">
      {loading && <Loading text={typeof loading === "string" && loading} />}
      <Prompt
        when={leaveAlert}
        message={() =>
          "Your report has unsaved changes. Are you sure you want to leave this page?"
        }
      />

      <h1 className="my-5">Custom Report Builder</h1>

      <Alert color="success" isOpen={!!success} toggle={() => setSuccess("")}>
        {success}
      </Alert>
      <Alert color="danger" isOpen={!!error} toggle={() => setError("")}>
        {error}
      </Alert>

      <Block
        headline="Accounts"
        description="Select an account and data access group"
        visible={!loading && dagsList && dagsList.length > 1}
      >
        <DagsDropdown
          dag={dag}
          setDag={setDag}
          dagsList={dagsList}
          report={report}
        />
      </Block>

      <Block step={1} headline="Report Name">
        <div className="builder__name">
          <div className="row">
            <div className="col-sm-6">
              <FormGroup>
                <Label className="builder__label" for="name">
                  Name
                  <sup>*</sup>
                </Label>
                <Input
                  type="text"
                  id="name"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  onBlur={e => setName(e.target.value.trim())}
                  autoFocus
                  disabled={loading}
                  invalid={invalidName}
                />
              </FormGroup>
              <FormGroup>
                <Label className="builder__label" for="description">
                  Description
                </Label>
                <Input
                  type="textarea"
                  id="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  disabled={loading}
                />
              </FormGroup>
            </div>
          </div>
        </div>
      </Block>

      <Block
        step={2}
        headline="Datasets"
        description="Select the datasets to use in the custom report"
        inactive={!!(!accountId && !dag && !datasetsList)}
        required
      >
        <Datasets
          datasetsList={datasetsList}
          datasetsRelationships={datasetsRelationships}
          datasets={datasets}
          setDatasets={setDatasets}
        />
      </Block>

      <Block
        step={3}
        headline="Filters"
        description="Add filter(s) to refine your query"
        inactive={!datasetsFieldsList || datasets.length === 0}
      >
        <Filters
          datasetsList={datasetsList}
          datasetsFieldsList={datasetsFieldsList}
          datasets={datasets}
          filters={filters}
          setFilters={setFilters}
        />
      </Block>

      <Block
        step={4}
        headline="Fields"
        description="Select and order the column(s) for your report table"
        inactive={!datasetsFieldsList || datasets.length === 0}
        required
      >
        <Fields
          datasetsList={datasetsList}
          datasetsFieldsList={datasetsFieldsList}
          datasets={datasets}
          fields={fields}
          setFields={setFields}
        />
      </Block>

      <Block
        step={5}
        headline="Schedule"
        description="Select an option for automated reporting"
        inactive={!datasetsFieldsList || fields.length === 0}
        visible
      >
        <Schedule
          schedule={schedule}
          setSchedule={setSchedule}
          expiration={expiration}
          setExpiration={setExpiration}
          timezone={timezone}
          setTimezone={setTimezone}
        />
        {schedule && (
          <IncrementalData
            datasets={datasets}
            datasetsList={datasetsList}
            incrementalDatasets={incrementalDatasets}
            setIncrementalDatasets={setIncrementalDatasets}
            incrementalDataShow={incrementalDataShow}
            setIncrementalDataShow={setIncrementalDataShow}
          />
        )}
      </Block>

      <Block>
        <SaveButtons
          accountId={accountId}
          extract_id={extractId}
          saveOpen={saveOpen}
          toggleSave={toggleSave}
          save={save}
          validateReport={validateReport}
          saveRunOpen={saveRunOpen}
          toggleSaveRun={toggleSaveRun}
        />
      </Block>
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className="report-name-modal"
        centered
      >
        <ModalBody>
          <FormGroup>
            <Label className="builder__block-headline" for="update-name">
              Update Extract Name?
            </Label>
            <Input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              onBlur={e => setName(e.target.value.trim())}
              invalid={name.length === 0 || name === " "}
              autoFocus
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color={save ? "primary" : "secondary"}
            outline
            disabled={name.length === 0 || name === " "}
            onClick={() => {
              validateReport(run, asNew);
              toggleModal();
            }}
          >
            {run ? "Save and Run As New" : "Save As New"}
          </Button>{" "}
          <Button
            color="link"
            onClick={() => {
              toggleModal();
              setName(nameOnLoad);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ExtractBuilder;
